module.exports = __webpack_public_path__ + "img/pro_seven_5.4f12a703.jpg";